import { Injectable } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  baseurl = environment.baseUrlParties;
  httpOptions = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
  notification$: BehaviorSubject<any> = new BehaviorSubject(null);
  notifications$: Observable<any> = this.notification$.pipe( mergeMap(() =>  this.getNotifications()) );

  constructor(public oktaAuth: OktaAuthService, private httpClient: HttpClient) { }

  private getNotifications(): Observable<any> {
    return this.httpClient.get(this.baseurl + '/me/notifications');
  }


  markRead(notificationRecipientId: string): Observable<any> {
    const data = {status: 'READ'};
    return this.httpClient.put(this.baseurl + '/me/notifications/' + notificationRecipientId, data, this.httpOptions);
  }

  // Delete Notification
  deleteNotification(notificationRecipientId: string): Observable<any> {
  return this.httpClient.delete(this.baseurl + '/me/notifications/' + notificationRecipientId);

  }

}
